import uniq from 'lodash/uniq';
import checkForDate from '../checkForDate';
import { sortTypes } from './sort.types';
import { sort } from './sorter';

var getChartSortType = function getChartSortType(chartConfig, data) {
    var ChartType = chartConfig.ChartType,
        SortAxis = chartConfig.SortAxis,
        XAxisField = chartConfig.XAxisField;

    var categoryField = getCategoryField(chartConfig);

    if (isFiscalSort(data[0][categoryField]) && categoryField.toLocaleLowerCase().indexOf('fiscal') >= 0) {
        //handle fiscal month and year
        return sortTypes.CATEGORY;
    } else if (categoryField && checkForDate(categoryField)) {
        //handle dates
        return sortTypes.DATE;
    } else if (SortAxis || ChartType.toLowerCase() === 'boxplot') {
        return sortTypes.CATEGORY;
    } else if (chartConfig.ChartType.toLowerCase() == 'waterfall' && chartConfig.Series[0].OrderField) {
        return sortTypes.SORT_ORDER;
    } else {
        //sort by value descending?
        return sortTypes.UNKNOWN;
    }
};

var isFiscalSort = function isFiscalSort(inputValue) {
    var fiscalMonth = /^[0-9]+[\s]*-[\s]*[a-zA-Z]+/;
    var fiscalMonthYear = /^[0-9]+-[0-9]+-[a-zA-Z]+/;

    return fiscalMonth.test(inputValue) || fiscalMonthYear.test(inputValue);
};

var getSeriesSortType = function getSeriesSortType(seriesConfig) {
    var FieldName = seriesConfig.FieldName,
        StackOnField = seriesConfig.StackOnField,
        SeriesType = seriesConfig.SeriesType;


    if (SeriesType.toLowerCase() === 'bar' || SeriesType.toLowerCase() === 'column') {
        return sortTypes.VALUE;
    } else {
        //sort by value descending?
        return sortTypes.UNKONWN;
    }
};

var helper = function helper(data, categoryField, valueField) {
    var sums = {};

    data.forEach(function (seriesData) {
        seriesData.forEach(function (d) {
            var value = d[valueField];

            sums[d[categoryField]] = (sums[d[categoryField]] || 0) + (value || 0);
        });
    });

    var categoryOrder = Object.keys(sums).sort(function (a, b) {
        return sums[b] - sums[a];
    });

    return categoryOrder;
};

var getDataForSeries = function getDataForSeries(chartConfig, seriesConfig, seriesDataObj) {
    var Series = chartConfig.Series;
    var SeriesName = seriesConfig.SeriesName;

    //Skip trend lines. Trend line series' do not have
    //data at this point.

    if (seriesConfig.IsTrendLine) return [];

    var otherSeries = Series.filter(function (seriesConfig) {
        return seriesConfig.SeriesName !== SeriesName;
    }).map(function (seriesConfig) {
        return seriesConfig.SeriesName;
    });

    if (seriesConfig.StackOnField || seriesConfig.GroupOnField) {

        //if the series is stacked and it's the only series, all the data is for this series
        if (Series.length === 1) return Object.keys(seriesDataObj).map(function (seriesName) {
            return seriesDataObj[seriesName];
        });

        //stacked and grouped series will only have one seriesConfig but many series data arrays
        var seriesNames = Object.keys(seriesDataObj).filter(function (seriesName) {
            return !otherSeries.includes(seriesName);
        });
        return seriesNames.map(function (seriesName) {
            return seriesDataObj[seriesName];
        });
    } else {
        //return empty array in case of series configuration with no data
        return seriesDataObj[SeriesName] ? [seriesDataObj[SeriesName]] : [];
    }
};

var getCategoryField = function getCategoryField(chartConfig) {
    var ChartType = chartConfig.ChartType,
        XAxisField = chartConfig.XAxisField,
        YAxisFields = chartConfig.YAxisFields,
        LabelField = chartConfig.LabelField;


    switch (ChartType.toLowerCase()) {
        case 'bar':
            return YAxisFields[0];
        case 'pie':
        case 'doughnut':
            return LabelField;
        default:
            return XAxisField || LabelField;
    }
};

var getCategoriesForSeries = function getCategoriesForSeries(chartConfig, seriesConfig, seriesDataObj) {
    var ChartType = chartConfig.ChartType,
        XAxisField = chartConfig.XAxisField,
        YAxisFields = chartConfig.YAxisFields;
    var FieldName = seriesConfig.FieldName;

    // const categoryField = ChartType.toLowerCase() === 'bar' ? YAxisFields[0] : XAxisField

    var categoryField = getCategoryField(chartConfig);

    if (!categoryField) return [];

    var data = getDataForSeries(chartConfig, seriesConfig, seriesDataObj);

    if (data.length === 0) return [];

    var seriesSortType = getSeriesSortType(seriesConfig);

    if (seriesSortType === sortTypes.VALUE) {
        return helper(data, categoryField, FieldName);
    }
    return data[0].map(function (d) {
        return d[categoryField];
    });
};

export var getCategoriesForChart = function getCategoriesForChart(chartConfig, seriesDataObj) {
    var ChartType = chartConfig.ChartType,
        Series = chartConfig.Series,
        SortAxis = chartConfig.SortAxis,
        XAxisField = chartConfig.XAxisField,
        YAxisFields = chartConfig.YAxisFields,
        InverseSort = chartConfig.InverseSort;

    var categoryField = getCategoryField(chartConfig);

    var categories = [];

    var allData = [];
    if (!seriesDataObj) return categories;
    Object.keys(seriesDataObj).map(function (seriesName) {
        var seriesData = seriesDataObj[seriesName];
        allData = [].concat(allData, seriesData);
    });

    //category sort, we need all categories from all series, then sort
    var chartSortType = getChartSortType(chartConfig, allData);

    if (chartSortType !== sortTypes.UNKNOWN) {

        if (chartConfig.ChartType.toLowerCase() == 'waterfall') var orderField = chartConfig.Series[0].OrderField;

        var sorted = sort(chartSortType, allData, categoryField, null, null, null, orderField);
        categories = sorted.map(function (x) {
            return x[categoryField] === null ? 'N/A' : x[categoryField];
        });
    }
    //value sort, category order will be determined by individual series value order
    else if (Series) {
            Series.forEach(function (seriesConfig) {
                //get the categories for the series
                var seriesCategories = getCategoriesForSeries(chartConfig, seriesConfig, seriesDataObj);

                categories = [].concat(categories, seriesCategories);
            });
        } else {
            return [];
        }

    categories = uniq(categories);

    return InverseSort ? categories.reverse() : categories;
};